var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.868,
    height: 26.404,
    viewBox: "0 0 12.868 26.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "j",
    transform: "translate(-4.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.234,18.973a3.237,3.237,0,0,1-.474-1.611V7.328a5.078,5.078,0,1,0-10.156,0V17.361a3.143,3.143,0,0,1-.46,1.584,6.449,6.449,0,0,0,1.53,8.314A6.4,6.4,0,0,0,13.7,28.654a6.139,6.139,0,0,0,1.489-.176,6.42,6.42,0,0,0,4.049-9.506ZM12.666,7.328a1.016,1.016,0,1,1,2.031,0V19.514a1.016,1.016,0,0,1-2.031,0Zm1.043,17.264a1.023,1.023,0,0,1-1.016-1.016,1.011,1.011,0,0,1,1-1.016h.014a1.016,1.016,0,1,1,0,2.031Z",
    transform: "translate(-3 1)",
    fill: "#2772af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ);
export default __webpack_public_path__ + "static/media/j.13b5a6a7d0185f4a96b5b56f92125689.svg";
export { ForwardRef as ReactComponent };